
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Route } from 'vue-router';
import store from '@/store';
import { Getter } from 'vuex-class';
import { Image, ImageMonth } from '@/types/image';
import { startCase } from 'lodash';
import ImageContainer from '@/components/ImageManager/ImageContainer.vue';

@Component({
  components: { ImageContainer },
})
export default class ImageManager extends Vue {
  @Getter('images/images') images!: Image[];
  @Getter('images/imageMonths') imageMonths!: ImageMonth[];

  get pageName() {
    const name = this.$route.name || undefined;
    return startCase(name);  }

  async beforeRouteEnter(to: Route, from: Route, next: Function) {
    const page = 1;
    await store.dispatch('images/getPage', { page });
    store.dispatch('images/getImageMonths');
    next();
  }
}
